import { render } from "./LetsTalkLayout.vue?vue&type=template&id=6a0553ca&scoped=true"
import script from "./LetsTalkLayout.vue?vue&type=script&lang=js"
export * from "./LetsTalkLayout.vue?vue&type=script&lang=js"

import "./LetsTalkLayout.vue?vue&type=style&index=0&id=6a0553ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0553ca"]])

export default __exports__